import { render, staticRenderFns } from "./PolizaMovilidad.vue?vue&type=template&id=04692dfc&scoped=true&"
import script from "./PolizaMovilidad.vue?vue&type=script&lang=js&"
export * from "./PolizaMovilidad.vue?vue&type=script&lang=js&"
import style0 from "./PolizaMovilidad.vue?vue&type=style&index=0&id=04692dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04692dfc",
  null
  
)

export default component.exports